import { ValidatorFn } from '@angular/forms';
import { ExtendedFormControl } from '../extended-form-control.class';

export class HiddenControl extends ExtendedFormControl {
    readonly inputType = 'hidden';

    constructor(name: string, value: string | number | boolean = '', validations: ValidatorFn[] = [], disabled = false) {
        super(name, value, validations, disabled);
    }
}
